<template>
    <div>
        <template v-if="showing">
            <button @click="stopSlideshow()">Stop</button>
        </template>
        <template v-else>
            <input type="text" v-model="query">
            <button @click="getSearch()">Generate</button>
        </template>
        <template v-if="images && images.length">
            <template v-for="(img, index) of images">
                <img v-show="index === currSlide" :key="img" :src="img" style="width: 100%;">
            </template>
        </template>
    </div>
</template>

<script>
import axios from 'axios';
import testJson from '@/assets/test.json';

export default {
    name: "App",
    computed: {
        totalSlides() {
            return this.images.length - 1;
        }
    },
    data() {
        return {
            showing: false,
            query: null,
            currSlide: 0,
            song: new Audio(require('@/assets/Agape.mp3')),
            json: testJson,
            images: null,
            slideshow: null
        }
    },
    methods: {
        getSearch() {
            this.song.currentTime = this.currSlide = 0;
            this.images = null;

            axios.get(`https://www.googleapis.com/customsearch/v1?key=AIzaSyD0gcvNJixSLIC5hwd4taYfk61vAWH8WOs&cx=329787f437b88432a&searchType=image&q=${this.query}`)
            .then(res => {
                const response = res.data;
                this.images = response.items.map(x => x.link);
                this.startSlideshow();
            })
            .catch(err => {
                alert(err);
            })
        },
        startSlideshow() {
            this.showing = true;
            this.song.play();
            this.slideshow = setInterval(() => {
                if(this.currSlide < this.totalSlides)
                    this.currSlide++
                else
                    this.currSlide = 0;
            }, 8000);
        },
        stopSlideshow() {
            this.song.pause();
            clearInterval(this.slideshow);
            this.slideshow = null
            this.showing = false;
        }
    },
}
</script>

<style>
/* Fade transition */
.fade-enter-active, .fade-leave-active {
    transition: opacity .25s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/App.vue